import { useSelector } from 'react-redux'
import { ApplicationState } from 'redux/Stores/types'
import {
  selectOrganizationalUnitsArray,
  selectOrganizationalUnitsFetched,
  selectOrganizationalUnitById,
  selectDefaultOrganizationalUnits,
  selectFullAccessEnum
} from 'redux/selectors/OrganizationalUnits'
import {
  TDefaultOrganizationalUnit,
  TOrganizationalUnit
} from 'types/GlobalOrganizationalUnit'

/**
 * Hook for getting all organizational units as an array
 * @returns organizational units array
 */
export const useOrganizationalUnitsArray = (): TOrganizationalUnit[] => {
  return useSelector(selectOrganizationalUnitsArray)
}

/**
 * Hook for getting all organizational units as an array
 * @returns organizational units array
 */
export const useDefaultOrganizationalUnits =
  (): TDefaultOrganizationalUnit[] => {
    return useSelector(selectDefaultOrganizationalUnits)
  }

/**
 * Hook for getting all organizational units as an array
 * @returns organizational units array
 */
export const useFullAccessEnum = (): string => {
  return useSelector(selectFullAccessEnum)
}

/**
 * Hook for getting organizational units loading state
 * @returns loading state
 */
export const useOrganizationalUnitsFetched = (): boolean => {
  return useSelector(selectOrganizationalUnitsFetched)
}

/**
 * Hook for getting a specific organizational unit by ID
 * @param id - Organizational unit ID
 * @returns organizational unit or undefined
 */
export const useOrganizationalUnitById = (
  id: string
): TOrganizationalUnit | undefined => {
  return useSelector((state: ApplicationState) =>
    selectOrganizationalUnitById(id)(state)
  )
}
